import { Injectable } from '@angular/core';
import { ErrorPage } from '../models/errorPage.model';
import { PathRoutes } from './pathRoutes';
@Injectable()
export class Errors {
  public static sessionExpired: ErrorPage = {
    title: 'Sesión caducada',
    description:
      'Su sesión ha expirado, para continuar, debe de volver a iniciar sesión.',
    showButton: true,
    textButton: 'Login',
    pathButton: PathRoutes.login,
  };
  public static forbidden: ErrorPage = {
    title: 'Acceso denegado',
    description: 'No tiene permisos para acceder al recurso.',
    showButton: true,
    textButton: 'Volver',
    pathButton: PathRoutes.home,
  };
}
